import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Home from "./Pages/Home";
import Landing from "./Pages/Landing";
import LegalNotices from "./Pages/LegalNotices/LegalNotices.view";
import { AccountLayout } from "./layouts/AccountLayout";
import { OrdersPage } from "./Pages/OrdersPage/OrdersPage.view";
import { ProfilePage } from "./Pages/ProfilePage/ProfilePage.view";
import { OrderTracking } from "./Pages/OrderTracking/OrderTracking";
import PaymentSummary from "./Pages/PaymentSummary";

import {
  ACCOUNT_ORDERS_ROUTE,
  ACCOUNT_PROFILE_ROUTE,
  ORDER_TRACKING_ROUTE,
} from "./constants/routes";
import { isQrCode } from "./utils";
import { Elements } from "@stripe/react-stripe-js";

const PageTransition = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 15 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -15 }}
    transition={{ duration: 0.25 }}
    style={{ height: "100%" }}
  >
    {children}
  </motion.div>
);

const renderPaymentRoute = (stripe) => {
  const paymentSummaryPath = isQrCode()
    ? "/qrcode/:shopIdFromLink/payment-summary"
    : "/payment-summary";

  return (
    <Route
      path={paymentSummaryPath}
      element={
        <PageTransition>
          <Elements stripe={stripe}>
            <PaymentSummary />
          </Elements>
        </PageTransition>
      }
    />
  );
};
export default function AppRoutes({
  landingEnabled,
  singlePageEnabled,
  stripe,
}) {
  const location = useLocation();

  const showMainApp = !landingEnabled || singlePageEnabled;
  const showLandingMode = !singlePageEnabled && landingEnabled;
  const showFallbackPayment = !singlePageEnabled && !landingEnabled;

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/mentions-legales"
          element={
            <PageTransition>
              <LegalNotices />
            </PageTransition>
          }
        />

        <Route
          path={ORDER_TRACKING_ROUTE}
          element={
            <PageTransition>
              <OrderTracking />
            </PageTransition>
          }
        />
        {showMainApp && (
          <>
            <Route
              path="/qrcode/:shopIdFromLink/orderTraking"
              element={
                <PageTransition>
                  <OrderTracking />
                </PageTransition>
              }
            />

            <Route
              path="/qrcode/:shopIdFromLink/*"
              element={
                <PageTransition>
                  <Home />
                </PageTransition>
              }
            />

            <Route path="/account" element={<AccountLayout />}>
              <Route
                path={ACCOUNT_ORDERS_ROUTE}
                element={
                  <PageTransition>
                    <OrdersPage />
                  </PageTransition>
                }
              />
              <Route
                path={ACCOUNT_PROFILE_ROUTE}
                element={
                  <PageTransition>
                    <ProfilePage />
                  </PageTransition>
                }
              />
            </Route>

            {renderPaymentRoute(stripe)}

            <Route
              path="/:shopId"
              element={
                <PageTransition>
                  <Home />
                </PageTransition>
              }
            />

            <Route
              path="/"
              element={
                <PageTransition>
                  <Home />
                </PageTransition>
              }
            />
          </>
        )}

        {showLandingMode && (
          <>
            <Route
              path="/commander/*"
              element={
                <PageTransition>
                  <Home />
                </PageTransition>
              }
            />

            <Route
              path="/"
              element={
                <PageTransition>
                  <Landing />
                </PageTransition>
              }
            />
          </>
        )}
        {showFallbackPayment && renderPaymentRoute(stripe)}
      </Routes>
    </AnimatePresence>
  );
}
